var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopmentExpenditure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "44px",
    viewBox: "0 0 54 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hard--:-software"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.8125,
    y: 0.807692308,
    width: 50.375,
    height: 33.9230769,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 18.6875,
    y: 37.9615385,
    width: 14.625,
    height: 3.23076923
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    points: "8.25 3.25 0 12.9201325 8.15332463 22.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-Copy",
    transform: "translate(28.875000, 13.000000) scale(-1, 1) translate(-28.875000, -13.000000) ",
    points: "33 3.25 24.75 12.9201325 32.9033246 22.75"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2,
    y1: 25.1875,
    x2: 19.8,
    y2: 0.8125,
    id: "Line-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentExpenditure);
export default __webpack_public_path__ + "static/media/developmentExpenditure.34a877d61bf2f8daa37f69a74cf1b445.svg";
export { ForwardRef as ReactComponent };